// extracted by mini-css-extract-plugin
export default {"edit_your_box":"ok","edit_box_title":"pk","subscription":"qk","byb":"rk","recommended_for_you_title":"sk","explore":"tk","recommended":"uk","go_back":"vk","wrapper":"wk","product_img":"xk","info":"yk","remove_btn":"zk"};
    if(module.hot) {
      // 1714442365912
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  